import React, { useState } from 'react';
import { compose } from 'recompose';
import propTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ViaModal from '../../../../components/library/viaModal';
import Headline from '../../../../components/library/headline';
import Button from '../../../../components/library/button';
import Paragraph from '../../../../components/library/paragraph';
import { getPlan, patchPlanUser } from '../../../../../actions/plans';
import sMakeGroupLead from './makeGroupLead.scss';

export const enhance = compose(withStyles(sMakeGroupLead));

function MakeGroupLead(props) {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  const makeLeads = () => {
    setSaving(true);
    const submitData = { plans_user:
        { group_lead: true }
    };

    props.planUsers.forEach((user, index, array) => {
      setTimeout(() => {
        dispatch(patchPlanUser(user, submitData));
      }, 500 * index);
    });

    setTimeout(() => {
      setSaving(false);
      dispatch(getPlan(props.planId));
      props.onClose(false);
    }, 500 * (props.planUsers.length + 1));
  };

  return (
    <>
      <ViaModal
        showing={props.show}
        onClose={() => props.onClose(false)}
      >
        <div className={sMakeGroupLead['make-group-lead']}>
          <div className={sMakeGroupLead.subHeader}>
            <Headline centered tag="h1" as="h1">
              Add Group Leader Access
            </Headline>
          </div>
          <div className={sMakeGroupLead.content}>
            <Paragraph size="large">
              You are about to add Group Leader access to one or more Travelers. They will be able to:
            </Paragraph>
          </div>
          <div className={sMakeGroupLead['content-list']}>
            <span>
              <ul>
                <li>View all Travelers on this plan</li>
                <li>View Traveler Itineraries on this plan</li>
                <li>Add, edit, or remove travel details in the Group Itinerary</li>
                {/* <li>Remove Travelers from this plan</li> */}
                {/* <li>Message Travelers on this plan</li> */}
                {/* <li>Cancel this plan</li> */}
              </ul>
            </span>
          </div>
          <div className={sMakeGroupLead.footer}>
            <div className={sMakeGroupLead['footer-confirm']}>
              <Headline tag="h2" as="h3" centered>
                Would you still like to add Group Leader access?
              </Headline>
            </div>
            <div className={sMakeGroupLead['footer-button-wrapper']}>
              <div className={sMakeGroupLead['button-content']}>
                <Button
                  display="secondary"
                  kind="solid"
                  size="medium"
                  onClick={() => {
                    props.onClose(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
              <div className={sMakeGroupLead['button-content']}>
                <Button
                  display="primary"
                  kind="solid"
                  size="medium"
                  type="submit"
                  onClick={() => makeLeads()}
                  loading={saving}
                  disabled={saving}
                >
                  Yes, Add Access
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ViaModal>
    </>
  )
}

MakeGroupLead.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  planId: propTypes.string.isRequired,
  planUsers: propTypes.array,
};

export default enhance(MakeGroupLead);
